export { TableNew } from './TableNew'
export type { RowsPerPageCount } from './components/RowsPerPage/types'
export type { TableData, TableCell, TableRow, ColumnHeader } from './types'
export type { Filter } from './utils/useTableFilter'
export { useTableFilter } from './utils/useTableFilter'
